import { GamepadSquareOutlineIcon } from './GamepadSquareOutlineIcon';

/**
 * author: Google
 * id 1370B995-F9FF-4B39-9414-055908214152
 * name gamepad-square-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-square-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerSquareOutlineIcon = GamepadSquareOutlineIcon;
export default ControllerSquareOutlineIcon